import { render } from "./CarrierIndex.vue?vue&type=template&id=22d48d5a"
import script from "./CarrierIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CarrierIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Carrier/CarrierIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22d48d5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22d48d5a', __exports__)) {
    api.reload('22d48d5a', __exports__)
  }
  
  module.hot.accept("./CarrierIndex.vue?vue&type=template&id=22d48d5a", () => {
    api.rerender('22d48d5a', render)
  })

}


export default __exports__